import type { ChangeEvent, FocusEvent } from 'react';
import React, { useRef } from 'react';

import type { TextInputProps } from 'src/components/atoms/TextInput/TextInput';
import { TextInput } from 'src/components/atoms/TextInput/TextInput';
import { VALIDATION_ERROR_MESSAGE, WEBLINK_REGEX } from './copy';

interface WeblinkInputProps extends TextInputProps {
  onWeblinkError: (errorMessage: string) => void;
}

export const isUrlInvalid = (value?: string | number | readonly string[]) => {
  return typeof value !== 'string' || value.match(WEBLINK_REGEX) === null;
};

export const WeblinkInput = (props: WeblinkInputProps) => {
  const weblinkRef = useRef<HTMLInputElement>(null);
  const {
    onBlur: delegatedOnBlur,
    onChange: delegatedOnChange,
    onWeblinkError,
    ...inputFieldProps
  } = props;

  const onBlur = (event: FocusEvent<HTMLInputElement>) => {
    const { value } = event.target;

    if (isUrlInvalid(value)) {
      onWeblinkError(VALIDATION_ERROR_MESSAGE);
    }

    if (delegatedOnBlur) {
      delegatedOnBlur(event);
    }
  };

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    if (document.activeElement !== weblinkRef.current && isUrlInvalid(value)) {
      onWeblinkError(VALIDATION_ERROR_MESSAGE);
    }

    if (delegatedOnChange) {
      delegatedOnChange(event);
    }
  };

  return <TextInput ref={weblinkRef} {...inputFieldProps} onBlur={onBlur} onChange={onChange} />;
};
